module.exports = __webpack_public_path__ + "static/media/ground-v2.659f26a0.png";